import React from "react";
import { useTranslation } from "react-i18next";
import { Item } from "../../../../components/Item";

export const QuoteHeaderRow = ({ items, hasAnnualRate = true }) => {
  const [t] = useTranslation();
  return (
    <div
      className={`quote-table__header ${
        hasAnnualRate ? "" : "quote-table__header--eurobonds"
      }`}
    >
      {items.map((title) =>
        title === "profitability" && !hasAnnualRate ? null : (
          <Item className="quote-table__header-item" key={title}>
            {t(title)}
          </Item>
        )
      )}
    </div>
  );
};
